import React from 'react';
import PropTypes from 'prop-types';

import {H, SmartSection } from "../common/SmartHeadings";

const StringUtil = require('../../../../app/shared/StringUtil');

// -- ChartTotalsBoxRow
const ChartTotalsBoxRowPropTypes = {
    children: PropTypes.node,
};

const ChartTotalsBoxRowDefaultProps = {};

export function ChartTotalsBoxRow(props) {
    return (
        <div className="stats-range-chart-totals-row">
            {props.children}
        </div>
    );
}

ChartTotalsBoxRow.propTypes = ChartTotalsBoxRowPropTypes;
ChartTotalsBoxRow.defaultProps = ChartTotalsBoxRowDefaultProps;
// ----------------


// -- ChartTotalsBox
const ChartTotalsBoxPropTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
};

const ChartTotalsBoxDefaultProps = {
    className: '',
    title: '',
    children: null,
};

export function ChartTotalsBox(props) {
    return (
        <ul className={`stats-range-chart-totals ${props.className}`}>
          <SmartSection component={
            (!!props.title) &&
                <li className="stats-range-chart-item-header">
                    <H>{props.title}</H>
                </li>
            }>
            {props.children}
          </SmartSection>
        </ul>
    );
}

ChartTotalsBox.propTypes = ChartTotalsBoxPropTypes;
ChartTotalsBox.defaultProps = ChartTotalsBoxDefaultProps;
// ----------------


// -- ChartTotalsBoxItem
const ChartTotalsBoxItemPropTypes = {
    className: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node
};

const ChartTotalsBoxItemDefaultProps = {
    className: '',
    label: '',
    value: '',
};

export function ChartTotalsBoxItem(props) {
    let parsedValue = props.value;
    if (typeof props.value === 'number' || isNaN(parseInt(props.value, 10))) {
        parsedValue = StringUtil.numberToLocaleString(props.value);
    }

    return (
        <li className={`stats-range-chart-item ${props.className}`}>
            <label>{props.label}</label>
            <span>{parsedValue}</span>
        </li>
    );
}

ChartTotalsBoxItem.propTypes = ChartTotalsBoxItemPropTypes;
ChartTotalsBoxItem.defaultProps = ChartTotalsBoxItemDefaultProps;
// ----------------